import { PublicTokenApiClient } from '@fourthwall/services/dist/PublicTokenApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeletePublicTokenMutation = createMutationHook(
  PublicTokenApiClient.removePublicToken,
  {
    mutationKey: ['deletePublicToken'],
  },
)
